/**
 * Las páginas de sistema que la automotora escondió desde el Builder.
 *
 * Vive en su propio módulo, y no en `page-builder-data`, porque ese importa
 * `baseResolver` —o sea, todo el árbol de componentes del builder— y la barra
 * de navegación necesita este dato: importarlo desde ahí cerraba un ciclo
 * (BuilderRenderer → BuilderNavbar → BuilderNavbarView → page-builder-data →
 * BuilderRenderer) y arrastraba el bundle entero al cliente. Acá no hay
 * dependencias: entra la fila de `client_website_config` y salen slugs.
 *
 * `home` se descarta siempre: no se puede esconder, y dejarlo pasar haría
 * desaparecer el enlace a la raíz.
 */
export function getHiddenSystemPages(config: any): string[] {
  if (!config?.elements_structure) return [];
  const structure = config.elements_structure;
  let envelope: any = null;
  if (typeof structure === 'object' && structure !== null) {
    envelope = structure;
  } else {
    try {
      envelope = JSON.parse(String(structure));
    } catch {
      return [];
    }
  }
  const hidden = envelope?.hiddenSystemPages;
  return Array.isArray(hidden)
    ? hidden.filter((s: any) => typeof s === 'string' && s !== 'home')
    : [];
}
